import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

/**
 * 侧边栏导航 + 顶栏,对应 §10.1 RBAC:配置页链接仅 Admin 可见
 * (即使前端隐藏了入口,后端配置写接口本身也应做角色校验,§9 handlers 注释里说明)。
 */
export function Layout({ children }: { children: ReactNode }) {
  const { username, roles, isAdmin, logout } = useAuth();

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-title">Kiro 用户管理平台</div>
        <nav className="sidebar-nav">
          <NavLink to="/dashboard" className={({ isActive }) => (isActive ? "active" : "")}>
            运营看板
          </NavLink>
          <NavLink to="/users" className={({ isActive }) => (isActive ? "active" : "")}>
            用户列表
          </NavLink>
          <NavLink to="/cost-summary" className={({ isActive }) => (isActive ? "active" : "")}>
            Cost Summary
          </NavLink>
          <NavLink to="/users/create" className={({ isActive }) => (isActive ? "active" : "")}>
            批量建号
          </NavLink>
          {isAdmin && (
            <NavLink to="/users/export" className={({ isActive }) => (isActive ? "active" : "")}>
              导出用户
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/subscriptions/import" className={({ isActive }) => (isActive ? "active" : "")}>
              导入订阅状态
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/config" className={({ isActive }) => (isActive ? "active" : "")}>
              配置页
            </NavLink>
          )}
          <NavLink to="/audit-log" className={({ isActive }) => (isActive ? "active" : "")}>
            审计日志
          </NavLink>
          <div className="sidebar-title" style={{ marginTop: 12, fontSize: 13 }}>
            Kiro-Go 舰队
          </div>
          <NavLink to="/fleet/create" className={({ isActive }) => (isActive ? "active" : "")}>
            创建
          </NavLink>
          <NavLink to="/fleet/instances" className={({ isActive }) => (isActive ? "active" : "")}>
            列表
          </NavLink>
          <NavLink to="/fleet/stats" className={({ isActive }) => (isActive ? "active" : "")}>
            统计
          </NavLink>
          {isAdmin && (
            <NavLink to="/fleet/sync-subscription" className={({ isActive }) => (isActive ? "active" : "")}>
              同步订阅到期日
            </NavLink>
          )}
        </nav>
      </aside>
      <div className="main">
        <div className="topbar">
          <div />
          <div>
            <span style={{ marginRight: 12, fontSize: 13, color: "#64748b" }}>
              {username} ({roles.join(", ") || "无角色"})
            </span>
            <button onClick={logout}>退出登录</button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
